import type { IMasterDataProductRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataProductDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataProductUseCase {
  private readonly repository: IMasterDataProductRepository;

  constructor(repository: IMasterDataProductRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataProductDTO) {
    return this.repository.updateProduct(params);
  }
}
